export interface AssociationPresentation {
  appName: string;
  shortName: string;
  iconBase: string;
  wvcea: boolean;
}

export interface AssociationPresentationData {
  appName?: string;
  appShortName?: string;
  appIconBase?: string;
  associationId?: string;
}

/**
 * Read-only host presentation written into the document by the tenant-resolving Worker.
 *
 * Answers the platform's own defaults where there is no document to read. A component that
 * only wanted to write "My WVCEA" on a back link should not be the reason a page cannot be
 * rendered outside a browser, which is what a test rendering to a string does.
 */
export function associationPresentation(): AssociationPresentation {
  if (typeof document === "undefined") return associationPresentationFromData({});
  return associationPresentationFromData(document.documentElement.dataset);
}

export function associationPresentationFromData(root: AssociationPresentationData): AssociationPresentation {
  const appName = root.appName?.trim() || "Verity Connect";
  const shortName = root.appShortName?.trim() || appName;
  const iconBase = root.appIconBase?.trim() || "/brand/verity";
  return { appName, shortName, iconBase, wvcea: root.associationId === "association_wvcea" };
}

export function personalWorkspaceName(): string {
  const presentation = associationPresentation();
  return presentation.wvcea ? "My WVCEA" : `My ${presentation.shortName}`;
}
